export default __webpack_public_path__ + "static/media/outgoing_call.84dceefd.mp3";